<template>
  <div class="layout">
    <div class="container flex-column" id="content">
      <div class="total-case flex-spacebetween-aligncenter">
        <div class="total-case-box">
          <span>총</span>&nbsp;
          <span>{{ this.total }}</span>
          <span>건이 검색되었습니다.</span>
        </div>
        <select
          name="정렬순서"
          id="newest"
          class="custom-selectbox short-selectbox"
          title="정렬순서"
          v-model="searchOrderBy"
          @change="sortList"
        >
          <option value="DESC">발간연도 내림차순</option>
          <option value="ASC">발간연도 오름차순</option>
        </select>
      </div>
      <div class="card-wrapper flex-column">
        <search-card-item
          v-for="item in this.reportList"
          v-bind:key="item.anlDetailNo"
          :anlDetailNo="item.anlDetailNo"
          :reportInfo="item"
          :searchPageIndex="searchModel.page"
          :searchModel="searchModel"
        ></search-card-item>
      </div>
      <search-pagination
        :current-index="searchModel.page"
        :total-page-count="totalPageCount"
        :page-display-count="pagerCount"
        @onClickIndex="goSearchPaging"
      />
    </div>
  </div>
</template>

<script>
import { fetchSearchReportList } from "@/api/StatReportSearch.js";
import SearchCardItem from "@/components/keywordSearch/SearchCardItem";
import SearchPagination from "@/components/keywordSearch/SearchPagination";

export default {
  name: "StatReportListItemKeyWord",
  components: { SearchCardItem, SearchPagination },

  data() {
    return {
      total: 0,
      totalPageCount: 0,
      pagerCount: 10,
      reportList: [],
      searchOrderBy: "DESC",
    };
  },

  created() {},

  props: {
    searchModel: {
      type: Object,
      require: true,
      deep: true,
    },
  },
  watch: {
    searchModel: function () {
      this.$nextTick(() => {
        this.searchReportList();
      });
    },
  },
  methods: {
    searchReportList() {
      fetchSearchReportList(this.searchModel)
        .then((response) => {
          if (response.data) {
            this.reportList = response.data.data;
            this.total = response.data.total;
            this.totalPageCount = Math.ceil(this.total / this.searchModel.size);

            this.$router
              .replace({
                name: this.$route.name,
                query: { searchBy: this.searchModel.searchBy },
                params: {},
              })
              .catch(() => {});

            setTimeout(() => {
              // loading.close()
            }, 1000);
          } else {
            this.reportList = [];
            this.total = 0;
            this.totalPageCount = 0;
            // loading.close()
          }
        })
        .catch(() => {
          // loading.close()
        });
    },

    goSearchPaging(pageIndex) {
      this.searchModel.page = pageIndex;
      window.scrollTo(0,0)
      this.searchReportList();
    },

    sortList() {
      this.$emit("searchOrderBy", this.searchOrderBy);
    },
  },
};
</script>
<style scoped>
.card-wrapper {
  gap: 40px;
}
</style>
